<template>

   <!-- <div>
      <div class="row">
         <div class="col-8 text-start">
            <h4 style="padding-top: 20px;" class=" modal-title"><strong>Block Details</strong></h4>
         </div>
      </div>
   </div> -->
   
   <div class="row mt-2 mb-2 text-center">
      <h6 class="card-subtitle text-muted">Date Created: <strong>{{ formatDate(block.dateCreated) }}</strong></h6>
   </div>

   <form ref="editBlockFormRef" class="row g-0" style="gap: 0.5rem">
      <LoadingPage v-if="isLoading"></LoadingPage>
      <div>
         <label for="organisation">Block Name</label>
         <input type="text" id="blockName" :disabled="isContentTypeBlock || !$store.getters['auth/canEditContentLibrary']" v-model.trim="block.blockName" @blur="v$.block.blockName.$touch"
            class="form-control" placeholder="Block Name" />

         <span class="form-text text-danger" v-if="v$.block.blockName.$error">
            Block Name is required.
         </span>
      </div>

      <div>
         <label for="blockType">Block Type</label>
         <select disabled class="form-select" id="blockType" v-model.trim="block.blockType"
            @blur="v$.block.blockType.$touch">
            <option selected disabled value>Please choose...</option>
            <option v-for="blockType in blockTypes" :value="blockType.id" :key="blockType.id">{{ blockType.display_name
               }}
            </option>
         </select>

         <span class="form-text text-danger" v-if="v$.block.blockType.$dirty && block.blockType == ''">
            Block Type is required.
         </span>
      </div>

      <div>
         <label for="blockUse">Block Use </label>
         <select class="form-select" id="blockUse" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model.trim="block.blockUse" @blur="v$.block.blockUse.$touch">
            <option selected disabled value>Please choose...</option>
            <option v-for="bUse in blockUse" :value="bUse.id" :key="bUse.id">{{ bUse.display_name }}
            </option>
         </select>

         <span class="form-text text-danger" v-if="v$.block.blockUse.$dirty && block.blockUse == ''">
            Block Use is required.
         </span>
      </div>

      <!-- <div class="form-check" style="margin-top: 5px;">
         <input class="form--check-input" type="checkbox" v-model="block.defaultVersion" id="defaultCheck1" checked>
         <label class="form--check-label" for="defaultCheck1">
            Default Version
         </label>
      </div> -->

      <div v-if="!isTestimonialBlock" class="form-check d-flex align-items-center" style="margin-top: 5px;">
         <input class="form--check-input" type="checkbox" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model="block.defaultVersion" id="defaultCheck1" checked>
         <label class="form--check-label mb-2" for="defaultCheck1">
            Default Version
         </label>
      </div>

      

      <div v-if="isProductServiceBlock" style="position: relative;">
         <label>Products</label>

         <!-- Selected products shown as removable tags -->
         <div v-if="block.products && block.products.length > 0" class="selected-products-tags">
            <span v-for="(p, idx) in block.products" :key="'sel-' + p.id" class="product-tag">
               {{ p.display_name }}
               <span v-if="$store.getters['auth/canEditContentLibrary']" class="product-tag-remove" @click.stop="removeProduct(idx)">&times;</span>
            </span>
         </div>

         <div class="d-flex align-items-center" style="gap: 0.5rem">
            <input type="text" class="form-control"
               :value="block.products && block.products.length > 0 ? block.products.length + ' product(s) selected' : ''"
               readonly placeholder="No products selected" />
            <button v-if="$store.getters['auth/canEditContentLibrary']" type="button" class="browse-btn" @click.stop="showProductPopup = !showProductPopup">
               <i class="fa-solid fa-magnifying-glass"></i> Browse
            </button>
         </div>

         <!-- Inline Product Browser Panel -->
         <div v-if="showProductPopup" class="product-panel" @click.stop>
            <div class="product-panel-header">
               <span class="product-panel-title">Select Products</span>
               <span class="product-panel-close" @click.stop="showProductPopup = false">&times;</span>
            </div>
            <div class="product-panel-tabs">
               <div class="product-panel-tab" :class="{ active: productTab === 'auth' }"
                  @click.stop="productTab = 'auth'">Auth Products</div>
               <div class="product-panel-tab" :class="{ active: productTab === 'internal' }"
                  @click.stop="productTab = 'internal'">Internal Products</div>
            </div>
            <div class="product-panel-search">
               <input type="text" v-model="productSearchQuery" placeholder="Search products..." />
            </div>
            <div class="product-panel-list">
               <template v-if="productTab === 'auth'">
                  <div v-for="item in filteredAuthProducts" :key="'auth-' + item.id"
                     class="product-panel-row" :class="{ 'product-panel-row-selected': isProductSelected(item) }"
                     @click.stop="toggleProduct(item)">
                     <div class="product-panel-row-badge">{{ item.id }}</div>
                     <div class="product-panel-row-info">
                        <div class="product-panel-row-name">{{ item.display_name }}</div>
                     </div>
                     <div class="product-panel-row-action">
                        {{ isProductSelected(item) ? '✓ Selected' : 'Select' }}
                     </div>
                  </div>
                  <div v-if="filteredAuthProducts.length === 0" class="product-panel-empty">No auth products found</div>
               </template>
               <template v-if="productTab === 'internal'">
                  <div v-for="item in filteredInternalProducts" :key="'int-' + item.id"
                     class="product-panel-row" :class="{ 'product-panel-row-selected': isProductSelected(item) }"
                     @click.stop="toggleProduct(item)">
                     <div class="product-panel-row-badge uuid">{{ item.id.substring(0, 8) }}...</div>
                     <div class="product-panel-row-info">
                        <div class="product-panel-row-name">{{ item.display_name }}</div>
                     </div>
                     <div class="product-panel-row-action">
                        {{ isProductSelected(item) ? '✓ Selected' : 'Select' }}
                     </div>
                  </div>
                  <div v-if="filteredInternalProducts.length === 0" class="product-panel-empty">No internal products found</div>
               </template>
            </div>
         </div>
      </div>

      <!-- Testimonial Multi-Product Selection (keeps VueMultiselect) -->
      <div v-if="isTestimonialBlock">
         <label for="products">Products</label>
         <VueMultiselect id="products" :disabled="!$store.getters['auth/canEditContentLibrary']" v-model="block.products" :options="productList" :multiple="true"
            open-direction="top" :close-on-select="true" label="display_name" track-by="id" :searchable="false"
            placeholder="Please choose at least one...">
         </VueMultiselect>
      </div>

      <div v-if="isContentTypeBlock">
         <label for="products">Content Type</label>
         <VueMultiselect id="content_type" :disabled="isContentTypeBlock || !$store.getters['auth/canEditContentLibrary']" v-model="block.contentType" :options="contentTypes" :multiple="false"
            open-direction="top" :close-on-select="true" label="display_name" track-by="id" :searchable="false"
            placeholder="Please choose one...">
         </VueMultiselect>
      </div>

      <div>
         <label for="color_header">Header Color</label>
         <div class="color-swatch-row">
            <button v-if="!presetColors.some(c => c.hex === block.color)" type="button"
               class="color-swatch color-swatch-active"
               :style="{ backgroundColor: block.color }"
               title="Current Color">
               <i class="fa-solid fa-check" style="font-size:10px;color:#fff;text-shadow:0 0 2px rgba(0,0,0,0.5);"></i>
            </button>
            <button v-for="c in presetColors" :key="c.hex" type="button"
               class="color-swatch" :class="{ 'color-swatch-active': block.color === c.hex }"
               :style="{ backgroundColor: c.hex }"
               :title="c.label"
               @click.stop="$store.getters['auth/canEditContentLibrary'] ? block.color = c.hex : null">
               <i v-if="block.color === c.hex" class="fa-solid fa-check" style="font-size:10px;color:#fff;text-shadow:0 0 2px rgba(0,0,0,0.5);"></i>
            </button>
            <button v-if="$store.getters['auth/canEditContentLibrary']" type="button" class="color-swatch color-swatch-custom" data-bs-toggle="popover"
               @click="toggleColorPicker($event, block.id, block.color, 'circle')"
               title="Custom Color">
               <i class="fa-solid fa-palette" style="font-size:12px;color:#435666;"></i>
            </button>
         </div>
         <div class="color-preview-strip" :style="{ backgroundColor: block.color }">
            <span class="color-preview-label">{{ block.color }}</span>
         </div>
      </div>

      <div id="popover" class="d-none" role="tooltip">
         <ColorPicker ref="colorPickerPopoverRef" @onColorChange="onColorChange" />
      </div>


      <!-- <div class="add-space">
       </div> -->
      <!-- <div class="pt-3 pb-3 justify-content-center d-flex" style="gap:0.5rem">
         <button type="button" class="btn btn-info text-light" @click="updateBlock()">
            Update </button>
      </div> -->
   </form>

</template>

<script>
import moment from "moment";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
//  import { isEmpty } from '@/plugins/helper.js'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import ColorPicker from '@/components/Utilities/color-picker.vue'
import LoadingPage from '@/components/Utilities/vertex-loading.vue'
import { nextTick } from 'vue'; // Import nextTick
import { debounce, log } from '@/plugins/helper.js'

//const _ = require('lodash');

export default {

   components: {
      VueMultiselect,
      ColorPicker,
      LoadingPage,
   },

   setup() {
      return { v$: useVuelidate() }
   },

   emits: ['onSubmit', 'onDelete'],

   props: {
      item: {
         type: Object,
         // required: true,
      },
      id: {
         type: String,
      },
   },

   data() {
      return {
         currentDate: null,
         block: {
            id: "",
            dateCreated: null,
            blockName: '',
            blockType: '',
            blockUse: '',
            contentType: null,
            defaultVersion: true,
            color: "#4682B4",
            product: null,
            content: "",
            products: [],
         },
         blockTypes: [],
         blockUse: [],
         productList: [],
         contentTypes: [],
         isEditing: false,
         disabledWhenClicked: false,
         isLoading: false,
         debounceFn: null,
         currentBlockType: "none",
         currentBlockName: "none",
         isProductServiceBlock: false,
         isTestimonialBlock: false,
         isContentTypeBlock: false,
         authProducts: [],
         internalProducts: [],
         showProductPopup: false,
         productTab: 'auth',
         productSearchQuery: '',
      }
   },

   validations() {
      return {
         block: {
            blockName: { required },
            blockType: { required },
            blockUse: { required },
         },
      }
   },

   computed: {
      presetColors() {
         return [
            { hex: '#00A0C1', label: 'Vertex Cyan' },
            { hex: '#4682B4', label: 'Steel Blue' },
            { hex: '#26a59a', label: 'Teal' },
            { hex: '#4cb050', label: 'Green' },
            { hex: '#ffa727', label: 'Orange' },
            { hex: '#eb4165', label: 'Red Pink' },
            { hex: '#8e24aa', label: 'Purple' },
            { hex: '#aa47bc', label: 'Lilac' },
            { hex: '#ffeb3c', label: 'Yellow' },
            { hex: '#435666', label: 'Dark Grey' },
         ]
      },
      filteredAuthProducts() {
         const q = this.productSearchQuery.toLowerCase()
         return this.authProducts.filter(p => p.display_name.toLowerCase().includes(q))
      },
      filteredInternalProducts() {
         const q = this.productSearchQuery.toLowerCase()
         return this.internalProducts.filter(p => p.display_name.toLowerCase().includes(q))
      },
   },

   watch: {
      currentBlockType() {
         if(this.currentBlockName !== "none") {
            this.setHeaderTitle()
         }
      }
   },

   created() {
      this.init()
      this.debounceFn = debounce(() =>
         this.setContentIfNotEmpty()
         , 2500)

      this.setHeaderTitle()
   },

   mounted() {
      nextTick(() => {


      })
   },

   methods: {
      init() {
         this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getProductList()
         this.getBlockTypes()
         this.getBlockUse()
         this.getContentTypes()
         this.getAuthProductsList()
         this.getInternalProductsList()
      },

      toggleColorPicker(e, color, shape) {
         let element = e.target
         if (e.target) {
            element = e.target.closest('[data-bs-toggle="popover"]')

         }
         if (this.$refs.colorPickerPopoverRef != null) {
            this.$refs.colorPickerPopoverRef.showPopover(element, color, shape);
         }
      },

      formatDate(date) {
         return moment(date).format("DD-MMM-YYYY")
      },

      onColorChange(colorCode) {
         this.block.color = colorCode
      },

      editBlock(id) {
         this.getBlock(id)
         //this.debounceFn()
      },

      triggerDebounce() {
         this.debounceFn()
      },

      async setContentIfNotEmpty() {
         this.isLoading = true
         setTimeout(() => {
            this.isLoading = false
             if (this.block.content != undefined && this.block.content != null) {
                const isDisabled = !this.$store.getters['auth/canEditContentLibrary'];
                this.$parent.setContent(this.block.content, isDisabled)
             }
            //this.isLoading = false
            //this.toggleIsLoading()
         }, 2500)
      },

      async setHeaderTitle() {
         this.$parent.setHeaderTitle(this.currentBlockName)
      },

      toggleIsLoading() {
         this.isLoading = !this.isLoading
      },

      async getBlock(id) {
         this.isLoading = true;
         await this.$axios.get("/blocks/" + id)
            .then((response) => {
               this.block.id = response.data.block.id
               this.block.dateCreated = response.data.block.date_created
               this.block.blockName = response.data.block.block_name
               this.block.blockType = response.data.block.BlockType.id
               this.currentBlockType = response.data.block.BlockType.name
               this.currentBlockName = response.data.block.BlockType.display_name
               this.block.blockUse = response.data.block.BlockUse.id
               this.block.defaultVersion = response.data.block.default_version
               this.block.color = response.data.block.block_hex_color
               this.block.content = response.data.block.content
               this.block.contentType = response.data.block.content_type

               if(response.data.block.BlockType.name == "ProductService") {
                  this.isProductServiceBlock = true
               } else {
                  this.isProductServiceBlock = false
               }

               if(response.data.block.BlockType.name == "Testimonial") {
                  this.isTestimonialBlock = true
               } else {
                  this.isTestimonialBlock = false
               }

               if(response.data.block.BlockType.name == "Content") {
                  this.isContentTypeBlock = true
               } else {
                  this.isContentTypeBlock = false
               }

               if (response.data.block.products != undefined && response.data.block.products.length > 0) {
                  response.data.block.products.forEach(p => {
                     this.block.product = {
                        id: p.product_id.toString(),
                        display_name: p.Product.display_name
                     }
                     return
                  })

                   response.data.block.products.forEach(p => {
                     log("Product",p)
                     this.block.products.push({
                        id: p.product_id.toString(),
                        display_name: p.Product.display_name
                     })
                  })
               }
               //this.isLoading = false;
            })
            .catch((error) => {
               this.isLoading = false;
               console.log(error)
               //this.$toast.error(error)
            })
      },

      //added block type async function
      async getBlockTypes() {
         await this.$axios.get("/categories?name=BlockType")
            .then((response) => {
               this.blockTypes = response.data.category.subcategories.filter(bt => bt.name !== "Testimonial");
               //this.blockTypes = response.data.category.subcategories
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      //added block use async function
      async getBlockUse() {
         await this.$axios.get("/categories?name=BlockUse")
            .then((response) => {
               this.blockUse = response.data.category.subcategories
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      async getProductList() {
         await this.$axios.get("/categories?name=Products")
            .then((response) => {
               this.productList = []
               response.data.category.subcategories.forEach((p) => {
                  // let displayName = this.productList.filter(e => {return e.id == p.product_id}).map(e => (e.display_name)).toString()
                  this.productList.push({
                     id: p.id,
                     display_name: p.display_name
                  })
               })

            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      async getContentTypes() {
         await this.$axios.get("/categories?name=ContentType")
            .then((response) => {
               this.contentTypes = []
               response.data.category.subcategories.forEach((p) => {
                  this.contentTypes.push({
                     id: p.id,
                     display_name: p.display_name
                  })
               })
            })
            .catch((error) => {
               this.$toast.error(error.response.data.message)
            })
      },

      async getAuthProductsList() {
         await this.$axios.get("/auth-products")
            .then((response) => {
               this.authProducts = []
               const items = response.data.authProducts || []
               items.forEach((item) => {
                  if (item.Product) {
                     this.authProducts.push({
                        id: item.Product.id,
                        display_name: item.Product.display_name || 'Unnamed',
                     })
                  }
               })
            })
            .catch((error) => {
               console.error('Failed to fetch auth products', error)
            })
      },

      async getInternalProductsList() {
         await this.$axios.get("/get-product-pricing")
            .then((response) => {
               this.internalProducts = []
               const items = response.data.productPrices || []
               items.forEach((item) => {
                  if (this.isUUID(item.ProductID)) {
                     this.internalProducts.push({
                        id: item.ProductID,
                        display_name: item.DisplayName || 'Unnamed',
                     })
                  }
               })
            })
            .catch((error) => {
               console.error('Failed to fetch internal products', error)
            })
      },

      isUUID(val) {
         if (typeof val !== 'string') return false
         if (val.length !== 36) return false
         if (val[8] !== '-' || val[13] !== '-' || val[18] !== '-' || val[23] !== '-') return false
         return true
      },

      toggleProduct(item) {
         if (!this.block.products) {
            this.block.products = []
         }
         const idx = this.block.products.findIndex(p => p.id === item.id)
         if (idx >= 0) {
            this.block.products.splice(idx, 1)
         } else {
            this.block.products.push({
               id: item.id,
               display_name: item.display_name
            })
         }
      },

      isProductSelected(item) {
         if (!this.block.products) return false
         return this.block.products.some(p => p.id === item.id)
      },

      removeProduct(index) {
         this.block.products.splice(index, 1)
      },

      async mockUpdate() {
         this.isLoading = true
         let block = {
            block_name: this.block.blockName,
            block_use_id: this.block.blockUse,
            default_version: this.block.defaultVersion,
            block_hex_color: this.block.color,
            content: this.$parent.getContent(),
         }

         block.products = []
         this.block.products.forEach((p) => {
            block.products.push({
               product_id: p.id.toString()
            })
         })

         log(block)
         this.isLoading = false
      },

      async updateBlock() {
         this.isLoading = true

         log("blockType", this.block.blockType)

         let block = {
            block_name: this.block.blockName,
            block_use_id: this.block.blockUse,
            block_type_id: this.block.blockType,
            default_version: this.block.defaultVersion,
            block_hex_color: this.block.color,
            content_type_id: (this.block.contentType != undefined && this.block.contentType.id != "") ? this.block.contentType.id : null,
            content: this.$parent.getContent(),
         }

         // if(this.isTestimonialBlock) {
         //    block.default_version = true;
         // }


         log("The block", block)

         block.products = []
         // Both ProductService and Testimonial use the multi-select block.products array
         if (this.block.products != undefined && this.block.products != null) {
            this.block.products.forEach(p => {
               block.products.push({
                  product_id: p.id.toString()
               })
            })
         }

         await this.$axios.put("/blocks/" + this.$parent.$route.params.id, block)
            .then((response) => {
               if (response.data.success) {
                  this.resetForm()
                  this.editBlock(this.$parent.$route.params.id)
                  this.isLoading = false
                  this.$toast.success(response.data.message)
               } else {
                  this.isLoading = false
                  this.$toast.error(response.data.message)
               }
            })
            .catch((error) => {
               this.isLoading = false
               console.error(error)
               this.$toast.error(error.response.data.message)
            })
      },

      resetForm() {
         this.block.blockName = ""
         this.block.blockType = ""
         this.block.blockUse = ""
         this.block.defaultVersion = true
         this.block.products = []
         this.block.color = "#4682B4"
         this.block.content = ""
      },
   },

};

</script>

<style scoped>
.high {
   color: #EB1C24;
}

.low {
   color: #00A54F;
}

.medium {
   color: #F3994D;
}

select>option {
   color: #435666;
   /* border: 1px solid #D9D9D9; */
   /* border-radius: 5px; */
}

.btn {
   width: 7rem;
}

form label:not(#isCharityLbl) {
   color: #00A0C1;
   margin: 0.5rem 0;
}

input:not([type="checkbox"]),
select {
   height: 40px;
   border-radius: 10px;
   border: 1px solid #D9D9D9;
   color: #435666;
}

.form--check-label {
   /* Adjust spacing between checkbox and label */
   color: #495057 !important;
   font-size: 15px;
   align-items: center;
   /* Vertically center the content */
   justify-content: center;
   /* Horizontally center the content */
   /* Grayish color for the label */
}

.form--check-input {
   width: 20px;
   /* Increase width */
   height: 20px;
   /* Increase height */
   margin-left: -15px;
   margin-right: 10px;
   background-color: #00A0C1;
}

input[type=checkbox]{
    accent-color: #00A0C1;
}

.add-space {
   margin-bottom: 225px;
}

.btn-circle-color {
   width: 40px;
   height: 40px;
   padding: 6px 0px;
   border-radius: 15px;
   text-align: center;
   font-size: 12px;
   line-height: 1.42857;
   border: 1px solid #00A0C1;
   color: #00A0C1;
}

.browse-btn {
   white-space: nowrap;
   background: #435666;
   color: #fff;
   border: none;
   border-radius: 10px;
   padding: 8px 16px;
   font-size: 13px;
   font-weight: 600;
   cursor: pointer;
   display: flex;
   align-items: center;
   gap: 6px;
}

.browse-btn:hover {
   background: #00A0C1;
}

.product-panel {
   position: absolute;
   z-index: 100;
   left: 0;
   right: 0;
   margin-top: 8px;
   border: 1px solid #e0e0e0;
   border-radius: 12px;
   background: #fafbfc;
   box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.product-panel-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 10px 14px;
   border-bottom: 1px solid #eee;
}

.product-panel-title {
   font-weight: 700;
   color: #435666;
   font-size: 14px;
}

.product-panel-close {
   font-size: 22px;
   cursor: pointer;
   color: #999;
   line-height: 1;
}

.product-panel-close:hover {
   color: #dc3545;
}

.product-panel-tabs {
   display: flex;
   border-bottom: 1px solid #eee;
}

.product-panel-tab {
   flex: 1;
   text-align: center;
   padding: 8px 0;
   font-size: 12px;
   font-weight: 600;
   color: #666;
   cursor: pointer;
   transition: all 0.2s;
   border-bottom: 2px solid transparent;
}

.product-panel-tab.active {
   color: #00A0C1;
   border-bottom-color: #00A0C1;
}

.product-panel-search {
   padding: 8px 10px;
}

.product-panel-search input {
   width: 100%;
   border: 1px solid #ddd;
   border-radius: 8px;
   padding: 6px 10px;
   font-size: 13px;
   height: 34px;
}

.product-panel-list {
   overflow-y: auto;
   max-height: 220px;
   display: flex;
   flex-direction: column;
   gap: 6px;
   padding: 8px 10px;
}

.product-panel-row {
   display: flex;
   align-items: center;
   background: #fff;
   border-radius: 8px;
   border: 1px solid #e9ecef;
   overflow: hidden;
   cursor: pointer;
   transition: all 0.2s;
   flex-shrink: 0;
}

.product-panel-row:hover {
   box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
   border-color: #00A0C1;
}

.product-panel-row-selected {
   border-color: #00A0C1;
   background: #f0fafc;
}

.product-panel-row-selected .product-panel-row-action {
   color: #28a745;
}

.product-panel-row-badge {
   background: #435666;
   color: #fff;
   min-width: 70px;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 10px 6px;
   font-weight: 700;
   font-size: 0.75rem;
   text-align: center;
   word-break: break-all;
}

.product-panel-row-badge.uuid {
   background: #00A0C1;
   font-size: 0.7rem;
}

.product-panel-row-info {
   flex-grow: 1;
   padding: 8px 12px;
}

.product-panel-row-name {
   font-weight: 600;
   color: #333;
   font-size: 13px;
}

.product-panel-row-action {
   color: #00A0C1;
   font-weight: 600;
   font-size: 12px;
   padding-right: 12px;
   cursor: pointer;
   white-space: nowrap;
}

.product-panel-row-action:hover {
   text-decoration: underline;
}

.product-panel-empty {
   text-align: center;
   padding: 20px;
   color: #999;
   font-size: 13px;
}

.selected-products-tags {
   display: flex;
   flex-wrap: wrap;
   gap: 6px;
   margin-bottom: 8px;
   max-height: 160px;
   overflow-y: auto;
   padding: 4px 0;
}

.product-tag {
   display: inline-flex;
   align-items: center;
   gap: 4px;
   background: #e8f7fa;
   color: #435666;
   border: 1px solid #b8e6f0;
   border-radius: 16px;
   padding: 4px 10px;
   font-size: 12px;
   font-weight: 600;
}

.product-tag-remove {
   cursor: pointer;
   color: #999;
   font-size: 16px;
   line-height: 1;
   margin-left: 2px;
}

.product-tag-remove:hover {
   color: #dc3545;
}

/* --- Color Swatch Picker --- */
.color-swatch-row {
   display: flex;
   flex-wrap: wrap;
   gap: 6px;
   margin-top: 6px;
   align-items: center;
}

.color-swatch {
   width: 28px;
   height: 28px;
   border-radius: 50%;
   border: 2px solid transparent;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: all 0.2s ease;
   padding: 0;
   outline: none;
   box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}

.color-swatch:hover {
   transform: scale(1.15);
   box-shadow: 0 2px 8px rgba(0,0,0,0.25);
}

.color-swatch-active {
   border-color: #333;
   transform: scale(1.15);
   box-shadow: 0 0 0 2px #fff, 0 0 0 4px #333;
}

.color-swatch-custom {
   background: linear-gradient(135deg, #f8f9fa, #e9ecef) !important;
   border: 2px dashed #adb5bd;
}

.color-swatch-custom:hover {
   border-color: #00A0C1;
   background: linear-gradient(135deg, #e8f7fa, #d4f1f7) !important;
}

.color-preview-strip {
   margin-top: 8px;
   height: 28px;
   border-radius: 8px;
   transition: background-color 0.3s ease;
   position: relative;
   box-shadow: inset 0 1px 3px rgba(0,0,0,0.15);
}

.color-preview-label {
   position: absolute;
   right: 8px;
   top: 50%;
   transform: translateY(-50%);
   font-size: 12px;
   color: #fff;
   font-family: monospace;
   font-weight: 600;
   text-shadow: 0 1px 2px rgba(0,0,0,0.4);
}
</style>